if (!customElements.get("nosto-form")) {
  class NostoForm extends HTMLElement {
    constructor() {
      super();

      this.cartPage = window.location.pathname.startsWith(window.routes.cart_url);

      this.button = this.querySelector('button[type="submit"]');

      this.querySelector("form").addEventListener(
        "submit",
        this.onSubmit.bind(this)
      );
    }

    async onSubmit(event) {
      event.preventDefault();

      this.button.classList.add("loading");
      this.button.setAttribute("aria-disabled", true);

      const data = new FormData(event.target);
      const id = Number(data.get("id"));

      let properties = data.getAll("properties").reduce((acc, property) => {
        const [key, value] = property.split("=");
        acc[key] = value;
        return acc;
      }, {});

      const body = JSON.stringify({
        id,
        properties,
        sections: this.getSectionsToRender().map(({ section }) => section),
      });

      let json;

      try {
        json = await fetch(`${window.routes.cart_add_url}`, {
          ...window.fetchConfig(),
          ...{ body },
        }).then((response) => response.json());

        const attribution_key = data.get('attribution_key');

        window.nostojs(function (api) {
          api.recommendedProductAddedToCart(json.product_id, attribution_key);
        });

        this.button.classList.add("done");
        setTimeout(() => {
          this.button.classList.remove("done");
        }, 1000);
      } catch (error) {
        console.error(error);
      }

      this.button.classList.remove("loading");
      this.button.removeAttribute("aria-disabled");

      this.render(json);
    }

    render(json) {
      if (this.cartPage) {
        const cartItems = document.querySelector('cart-items');

        cartItems.currentItemCount += 1;
        cartItems.render(json);
      } else {
        document.querySelector("cart-notification").renderContents(json);
      }
    }

    getSectionsToRender() {
      if (this.cartPage) {
        return document.querySelector('cart-items').getSectionsToRender();
      } else {
        return document.querySelector("cart-notification").getSectionsToRender();
      }
    }
  }

  customElements.define("nosto-form", NostoForm);
}
